import {combineReducers} from "redux"
import feedback from "../tool/feedback"

const toolReducer = combineReducers({
    feedback,
})

export default toolReducer
